/* eslint-disable no-console */
import { authState$, logIn } from '@heimdall/client';
import { flog } from '@lseg-ciam/auth/login';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Subscription } from 'rxjs';
import { issuerUrls } from '../config.js';
import { rigSharedStyles } from './heimdall-rig-styles.js';

@customElement('heimdall-auto-login')
export class HeimdallAutoLogin extends LitElement {
  @state()
  _subscription: Subscription | null = null;

  @state()
  _authState = '×';

  onExpireIdpToken() {
    const idpTokenKey = 'heimdall:token:idp';
    const currentIdpToken = localStorage.getItem(idpTokenKey);

    if (currentIdpToken) {
      try {
        const tokenData = JSON.parse(currentIdpToken);
        tokenData.refreshInfo = { expiresBy: Date.now() - 1000 };
        localStorage.setItem(idpTokenKey, JSON.stringify(tokenData));
        new BroadcastChannel('heimdall:token:idp').postMessage(
          'Token expired by rig'
        );
        console.log('IDP token expired and broadcast sent.');
      } catch (e) {
        console.error('Failed to expire IDP token:', e);
      }
    } else {
      console.warn('No IDP token found in localStorage.');
    }
  }

  onSubscriptionRequestChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    const { checked } = target;

    if (!checked) {
      this._authState = '×';
      this._subscription?.unsubscribe();
      this._subscription = null;
      return;
    }

    this._subscription = authState$
      .pipe(flog('Auth state on AUTO LOGIN RIG'))
      .subscribe((authState: string) => {
        this._authState = authState;
        if (authState === 'LOGIN_EXPIRED' || authState === 'RECOVERING') {
          console.log(
            `%cATTEMPTING AUTO LOGIN (${authState})`,
            'color: green; background: powderblue; padding: 5px;'
          );
          try {
            logIn({
              clientUid: 'workspace',
              issuerUrl: issuerUrls['ppe'],
              fallback: { strategy: 'popup' },
              redirectUri: `${globalThis.location.origin}/public/heimdall/redirect/index.html`,
            });
          } catch (error) {
            console.error('Auto login failed: 💥', error);
          }
        }
      });
  }

  render() {
    return html`
      <div class="app">
        <h1>Heimdall Auto Login Rig</h1>
        <h2>${this._authState}</h2>
        <ul>
          <li>
            <label>
              <input
                type="checkbox"
                .checked=${!!this._subscription}
                @change=${this.onSubscriptionRequestChanged}
              />
              Attempt relogin to workspace on LOGIN_EXPIRED / RECOVERING
            </label>
          </li>
          <li>
            <button @click=${this.onExpireIdpToken}>
              Force Expire IDP token
            </button>
          </li>
        </ul>
      </div>
    `;
  }

  static styles = rigSharedStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-auto-login': HeimdallAutoLogin;
  }
}
